<ng-container *transloco="let convert;">
  <div class="edit-posting-form full-description-form">
    <h3 class="content-card-title d-none d-md-block">{{convert('sellModule.posting.fullDescriptionForm.textFullDes')}}</h3>
    <div class="content-card-subtitle">{{convert('sellModule.posting.fullDescriptionForm.textIdentified')}}</div>
    <div class="content-card-subtitle mb-4 mt-3 mt-md-0">{{convert('sellModule.posting.fullDescriptionForm.textConfirmOption')}}</div>
    <div class="fw-bold mb-3 label-font-size">{{convert('sellModule.posting.fullDescriptionForm.textRecognizedOption')}}</div>
    <ng-container>
      @for (vehicleOption of vehicleOptions; track vehicleOption; let i = $index) {
        <div>
          <div class="custom-control custom-checkbox mt-3">
            <input type="checkbox" class="custom-control-input form-control"
              id="{{i}}_vehicleOption"
              (change)="updateAdditionalOption($event, vehicleOption, 'excluded')"
              [checked]="!vehicleOption.excluded"
              [attr.aria-label]="getDescription(vehicleOption)" />
            <label for="{{i}}_vehicleOption"
            class="custom-control-label ms-2">{{getDescription(vehicleOption)}} </label>
          </div>
        </div>
      }
    </ng-container>
    <div class="fw-bold label-font-size mt-4 mb-3">{{convert('sellModule.posting.fullDescriptionForm.textMoreOption')}}</div>
    <ng-container>
      @for (vehicleAdvancedOption of vehicleAdditionalOptions; track vehicleAdvancedOption; let i = $index) {
        <div>
          <div class="custom-control custom-checkbox mt-3">
            <input type="checkbox" class="custom-control-input form-control"
              id="{{i}}_advanced"
              (change)="updateAdditionalOption($event, vehicleAdvancedOption, 'excluded')"
              [checked]="!vehicleAdvancedOption.excluded"
              [attr.aria-label]="vehicleAdvancedOption.optionDescription" />
            <label for="{{i}}_advanced"
            class="custom-control-label ms-2">{{vehicleAdvancedOption.optionDescription}} </label>
            <div class="custom-control custom-checkbox mt-3 mb-3 ms-2">
              <input type="checkbox" class="custom-control-input form-control"
                id="{{i}}_advanced-checkbox"
                (change)="updateAdditionalOption($event, vehicleAdvancedOption, 'afterMarket')"
                [checked]="vehicleAdvancedOption.afterMarket"
                [attr.aria-label]="vehicleAdvancedOption.afterMarket" />
              <label for="{{i}}_advanced-checkbox" class="custom-control-label ms-2">{{convert('sellModule.posting.fullDescriptionForm.textAftermarket')}} </label>
            </div>
          </div>
        </div>
      }
    </ng-container>
    @if (showAddOptionForm) {
      <div>
        <div class="row">
          <div class="col-lg-5 col-sm-12 pe-md-0">
            <input type="text" maxlength="40" class="form-control"
              id="new-option-input"
              placeholder="{{convert('sellModule.posting.fullDescriptionForm.placeholderAccessoryDes')}}"
              aria-required="true"
              [(ngModel)]="newAdditionalVehicleOption.optionDescription" />
            <div class="custom-control custom-checkbox aftermarket-add mt-3 mb-3">
              <input class="custom-control-input form-control" type="checkbox"
                id="newAfterMarket"
                [checked]="newAdditionalVehicleOption.afterMarket"
                [(ngModel)]="newAdditionalVehicleOption.afterMarket" />
              <label for="newAfterMarket" class="custom-control-label ms-2"> {{convert('sellModule.posting.fullDescriptionForm.textAftermarket')}} </label>
            </div>
          </div>
          <div class="col-lg-7 col-sm-12">
            <button data-track-elem="button" id="vehicle-option-add-button"
              data-track-name="Add"
              class="btn btn-outline-primary add-option-btn mb-3"
            (click)="addVehicleAdvancedOption()">{{convert('sellModule.posting.fullDescriptionForm.btnAdd')}}</button>
          </div>
        </div>
      </div>
    }
    <div>
      <button class="add-option-styles btn btn-link fw-bold ps-0"
        data-track-name="Add Another Option or Accessory"
        [attr.aria-label]="convert('sellModule.posting.fullDescriptionForm.ariaLabelAnotherOption')"
        (click)="toggleAnotherOptionForm()"
        allytm-click-tagged="true">
        + {{convert('sellModule.posting.fullDescriptionForm.ariaLabelAnotherOption')}}
      </button>
    </div>
  </div>
</ng-container>
